import { Component, Inject, OnInit } from "@angular/core";
import { WINDOW } from "../../providers/window-providers.service";

@Component({
  selector: 'app-contact',
  templateUrl: 'contact.component.html',
  styleUrls: ['contact.component.scss']
})
export class ContactComponent implements OnInit {

  constructor(@Inject(WINDOW) private window) { }

  ngOnInit() {
  }

  openFacebook() {
    this.window.open("https://www.facebook.com/iosmj");
  }

  openLinkedIn() {
    this.window.open("https://www.linkedin.com/in/madhanraj-r-449aa266/");
  }

  openGooglePlus() {
    this.window.open("https://plus.google.com/u/0/116068183483360672924");
  }

  openTwitter() {
    this.window.open("https://twitter.com/trmadhans");
  }

  openInstagram() {
    this.window.open("https://www.instagram.com/trmadhans/");
  }

  private symbol(): string {
    //return this.access.accessLevel >= AccessLevel.expert ? "\e911" : "\e917";
    return "&#xe92b";
  }
}



// WEBPACK FOOTER //
// ./src/components/contact/contact.component.ts